
const digest = 'c621fcdbcbaa83fe7d208ff45b44e3497a4b30e60caf25314336487e4a34a131';
const classes = {"wrapper":"_wrapper_1k1vl_1","list":"_list_1k1vl_9","scrollContainer":"_scrollContainer_1k1vl_17"};
const css = `._wrapper_1k1vl_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow: hidden;
  height: calc(100vh - 125px);
}
._wrapper_1k1vl_1 ._list_1k1vl_9 {
  position: relative;
  background: #ffffff;
  padding: 24px;
  border: 1px solid #eaedf3;
  overflow: hidden;
  height: 100%;
}
._wrapper_1k1vl_1 ._list_1k1vl_9 ._scrollContainer_1k1vl_17 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  